import React from 'react'
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle} from '@fortawesome/free-solid-svg-icons';
function RecepisseVote ({dataPerson}) {
    const [show, setShow] = useState(true);
    const handleClose = () => setShow(false);
  
    return (
      <>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header >
          <Modal.Title>Vote réussie</Modal.Title>
          <FontAwesomeIcon icon={faCheckCircle} className="green-icon m-2" size="lg" />
          </Modal.Header>
          <Modal.Body>
              <div className="container ">
              <div className='text-dark text-centered'>
                   <span style={{fontWeight:'bold'}}>Ton vote a été enregistrée .  </span> 
              </div>
              <div>
                      Merci d'avoir accompli ce devoir. : <span className='fw-bolder'>{dataPerson?.email}</span> 
                    </div>
              </div>
          </Modal.Body>
          <Modal.Footer>
          <Link to='/'>
                <Button variant="outline-success" onClick={handleClose}>
                  Fermer
                </Button>
                </Link>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
  export default RecepisseVote